import IconErrorPage from "@src/assets/icons/icon-error-page.svg?react";
import { useRouteError } from "react-router-dom";

export function MainLayoutError() {
	const error = useRouteError() as Error;

	console.error("error", error);

	const handleRefresh = () => {
		window.location.reload();
	};

	return (
		<div className="flex justify-center items-center p-4 min-h-screen">
			<div className="space-y-8 w-full max-w-xl">
				<div className="flex justify-center">
					<IconErrorPage className="w-14 h-14" />
				</div>

				<div className="space-y-3 text-center">
					<h1 className="text-2xl font-bold text-muted">
						Oops, something went wrong
					</h1>
					<p className="text-base font-normal text-muted">
						Please try again later or refresh the page
					</p>
				</div>

				{error && (
					<textarea
						className="p-3 w-full font-mono text-xs text-text-secondary whitespace-pre-wrap wrap-break-word bg-surface-default rounded-lg border border-border-subtle min-h-50 overflow-y-auto resize-none custom-scrollbar"
						value={
							error.name && error.message
								? `${error.name}: ${error.message}${error.stack ? `\n\n${error.stack}` : ""}`
								: error.message || error.name || "An unexpected error occurred"
						}
						readOnly
					/>
				)}

				<div className="flex justify-center">
					<button
						type="button"
						onClick={handleRefresh}
						className="px-4 py-2 text-sm font-medium text-text-primary bg-surface-default rounded-md border border-border-default transition-colors hover:bg-surface-hover-subtle hover:border-border-strong focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-border-strong"
					>
						Refresh
					</button>
				</div>
			</div>
		</div>
	);
}
